import { render } from "./DashboardV1.vue?vue&type=template&id=77599ac0&scoped=true"
import script from "./DashboardV1.vue?vue&type=script&lang=js"
export * from "./DashboardV1.vue?vue&type=script&lang=js"

import "./DashboardV1.vue?vue&type=style&index=0&id=77599ac0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77599ac0"]])

export default __exports__